export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_En.2b1cb3f6.webp";